// ==============================|| ID LISTS IN A QUERY STRING — KEEP THEM SHORT ||============================== //
//
// ⚠ A LONG QUERY STRING NEVER REACHES THE APP IN PRODUCTION. `?ids=<100 guids>` is ~3.9 KB, and the production
// host refuses a query string that long before the service sees it (IIS's default maxQueryString is 2,048
// characters). The browser gets no CORS headers on that refusal, so it surfaces as a bare "Failed to fetch" —
// which took the invoice list's export down twice. Nothing in dev shows it: Kestrel alone accepts 8 KB.
//
// So: a LIST should carry what it names (the services resolve people, schools, courses and countries per page
// — NAMES-SWEEP / INV-CTRY). What is left are genuine lookups by id; every one of them sends at most this many
// ids per request (40 × 39 chars ≈ 1.6 KB including the separators), and loops for more.

/** Most ids one GET may carry in a comma-joined query parameter. */
export const MAX_IDS_PER_QUERY = 40;

/** Splits ids into query-string-safe chunks of {@link MAX_IDS_PER_QUERY}. */
export function chunkIds<T>(ids: readonly T[], size: number = MAX_IDS_PER_QUERY): T[][] {
  const out: T[][] = [];
  for (let i = 0; i < ids.length; i += size) out.push(ids.slice(i, i + size));
  return out;
}
